import axios from "axios";
import { http } from "../client";
export var UserFileUploadVariant;
(function (UserFileUploadVariant) {
    UserFileUploadVariant[UserFileUploadVariant["FileSizeTooLarge"] = 0] = "FileSizeTooLarge";
    UserFileUploadVariant[UserFileUploadVariant["WrongFileType"] = 1] = "WrongFileType";
})(UserFileUploadVariant || (UserFileUploadVariant = {}));
var isUserFileUploadError = function (payload) {
    var _a;
    return (axios.isAxiosError(payload) &&
        typeof ((_a = payload.response) === null || _a === void 0 ? void 0 : _a.data.error) === "string");
};
var extractMessage = function (error) { var _a, _b; return (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error; };
var isErrorMessageEqualsTo = function (error, str) {
    return extractMessage(error) === str;
};
var checks = [
    {
        name: UserFileUploadVariant.FileSizeTooLarge,
        check: function (error) {
            return isErrorMessageEqualsTo(error, "Filesize too large");
        },
    },
    {
        name: UserFileUploadVariant.WrongFileType,
        check: function (error) {
            return isErrorMessageEqualsTo(error, "Only mp3, ogg, wav, flac, aac and aiff supported; image/png");
        },
    },
];
var mapErrorToFailureVariant = function (error) {
    if (isUserFileUploadError(error)) {
        var found = checks.find(function (_a) {
            var check = _a.check;
            return check(error);
        });
        if (found) {
            return found.name;
        }
    }
    return null;
};
export var uploadUserTrack = function (_a) {
    var title = _a.title, file = _a.file;
    var formData = new FormData();
    formData.append("title", title);
    formData.append("audio", file);
    return http.api
        .post("tracks", formData)
        .then(function (response) { return ({ trackId: response.data.track_id }); })
        .catch(function (error) { return Promise.reject(mapErrorToFailureVariant(error)); });
};
